import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Card, CardBody, Spinner } from "reactstrap";
// import rButton from "reactstrap/button";

import {
  deleteRequest,
  putRequest,
  postRequest,
  putRequestForm,
  RBButton,
  deleteConfirmationWords,
  ImageFileUpload,
  postRequestForm,
} from "components/Common/Utils";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { Link, NavLink } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { format } from "date-fns";
// import StarComponent from "./StarComponent";
import { QRCodeSVG } from "qrcode.react";

import Lightbox from "react-image-lightbox";

import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import GridListTileBar from "@material-ui/core/GridListTileBar";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Avatar,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";

import LocationPicker from "react-location-picker";
// import DayTimePicker from "./DayTimePicker";

import { makeStyles } from "@material-ui/core/styles";
import { ToastContainer, toast } from "react-toastify";
import UserOrderTable from "pages/UserManagement/UserOrderTable";
import DeliveryAgents from "components/Modal/DeliveryAgents";

export default function ManufacturerOrderDetails() {
  const location = useLocation();
  const _id = useParams();
  const state = location.state?.row;
  console.log(state);
  const [orderId, setOrderId] = useState({});
  const [userAllDetails, setuserAllDetails] = useState({});
  const [orderData, setUserOrderData] = useState({});
  const [loader, setLoader] = useState(false);
  const [imageLB, setImage] = React.useState("");
  const [images, setImages] = React.useState([]);
  const [openLightbox, setOpenLightBox] = React.useState(false);
  const [model, setModel] = useState(false);
  const [assingDeliveryModalData, setAssingDeliveryData] = useState({});

  const useStyles = makeStyles({
    tableHeader: {
      color: "#ffffff", // Use your preferred color
      backgroundColor: "#3f51b5", // Header background color
      fontWeight: "bold",
    },
    descriptionText: {
      fontSize: "0.8rem",
    },
    deleteIcon: {
      color: "red",
    },
    roundImage: {
      borderRadius: "50%",
      width: "75px",
      height: "75px",
    },
    roundImageSm: {
      borderRadius: "50%",
    },

    gridList: {
      width: "100%",
    },
    icon: {
      color: "rgba(255, 55, 25, 0.54)",
    },
  });

  useEffect(() => {
    fetchOrderDetails();
  }, [_id]);

  const fetchOrderDetails = async () => {
    setLoader(true);
    const payload = {
      orderId: _id?.id,
    };
    try {
      const response = await postRequest(`order/admin/order-details`, payload);
      const data = response.data;
      setUserOrderData(data);
      setuserAllDetails(data?.manufacture);
      console.log("table data", data);
    } catch (error) {
      console.log("Failed to fetch data:", error);
    } finally {
      setLoader(false);
    }
  };

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const showLightBox = (image) => {
    setImage(image);
    setOpenLightBox(true);
  };

  // const {
  //   first_name,
  //   last_name,
  //   image,
  //   country_code,
  //   gender,
  //   country,
  //   nationality,
  //   email,
  //   mobile,
  //   dob,
  //   createdAt,
  //   address,
  // } = userAllDetails;

  const [sortOrderId, setsortOrderId] = React.useState(null);

  const toggleModel = () => {
    console.log("toggleModel", model);
    setModel(!model);
  };

  const selectRow = (item) => {
    console.log({ item });
    setAssingDeliveryData({
      Image: item?.image,
      Title: item?.title,
      categoryId: item?._id,
      show: true,
    });
    deliveryAssingOrder(item?._id);
    setModel(false);
  };

  const deliveryAssingOrder = async (_id) => {
    setLoader(true);
    const payload = {
      orderId: sortOrderId,
      deliveryAgentId: _id,
    };
    try {
      const response = await postRequest(
        `order/assign-to-delivery-agent`,
        payload
      );
      if (response?.status) {
        fetchOrderDetails();
        // Show success message
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Order successfully assigned to the delivery agent!",
          confirmButtonText: "OK",
          timer: 2000, // Optional: automatically close after 2 seconds
        });
      }
    } catch (error) {
      console.log("Failed to fetch data:", error);
    } finally {
      setLoader(false);
    }
  };

  //upload
  const [isFileSelect, setIsFileSelect] = useState(false);
  const [veriFiedDocument, setveriFiedDocument] = useState([
    { documentImage: "" },
  ]);
  const [viewImg, setViewImg] = useState("");
  const [refrenshNumber, setRefrenshNumber] = useState("");
  const [ViewModal, setViewModal] = useState(false);

  const updateDocument = (key, files) => {
    setIsFileSelect(true);
    const updatedDocuments = Array.from(files).map((file) => {
      const previewUrl = URL.createObjectURL(file);
      return { [key]: file, previewUrl }; // Save the preview URL and the file
    });
    console.log(updatedDocuments);
    setveriFiedDocument(updatedDocuments);
  };

  const handleReceipt = async (id) => {
    try {
      let documentImages = [];
      if (isFileSelect) {
        for (const doc of veriFiedDocument) {
          const selectedImage = new FormData();
          selectedImage.append("image", doc.doc); // Ensure 'doc' key matches your data
          const selectedImageUrl = await postRequestForm(
            "image/img/upload",
            selectedImage
          );
          documentImages.push(selectedImageUrl?.data?.url || "");
        }
      }
      const response = await postRequest("order/admin-update-receipt", {
        orderId: id,
        paymentRefNumber: refrenshNumber,
        adminPayStatus: "paid",
        paymentRefImage: isFileSelect ? documentImages?.[0] : "",
      });
      if (response?.status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.message,
        });
        setveriFiedDocument([]);
        setRefrenshNumber("");
        setIsFileSelect(false);
        fetchOrderDetails();
      } else {
        console.error("Failed to update payment status:", response?.data);
      }
    } catch (error) {
      console.error("Error while updating payment status:", error);
    }
  };

  function handleCreditDays(item) {
    console.log(item?.createdAt);
    const orderDate = new Date(item?.createdAt);
    const todayDate = new Date();
    const diffInTime = todayDate - orderDate;
    const diffInDays = Math.floor(diffInTime / (1000 * 60 * 60 * 24));
    const remainingDays = item?.manufacture?.creditDays - diffInDays;
    return <span>{remainingDays} Day</span>;
  }

  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedProductsData, setSelectedProductsData] = useState([]);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      // Select only products where deliveryStatus is 'pending'
      const pendingIds =
        orderData?.products
          ?.filter((item) => item.deliveryStatus === "pending")
          .map((item) => item.productId) || [];

      const filterData =
        orderData?.products
          ?.filter((item) => item.deliveryStatus === "pending")
          .map((item) => item) || [];

      setSelectedProducts(pendingIds);
      setSelectedProductsData(filterData);
    } else {
      setSelectedProducts([]);
    }
  };

  const handleSelectOne = (e, id, item) => {
    setSelectedProducts((prev) => {
      const updatedProducts = prev.includes(id)
        ? prev.filter((pid) => pid !== id)
        : [...prev, id];
      console.log("Updated Selected Products:", updatedProducts);
      return updatedProducts;
    });
    setSelectedProductsData((prev) => {
      if (e.target.checked) {
        return [...prev, item]; // Add product item
      } else {
        return prev.filter((p) => p._id !== _id); // Remove product item
      }
    });
  };

  const closeModalDeleveryAgent = () => {
    setModel(false);
  };

  const [openLightboxQR, setOpenLightboxQR] = useState(false);
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState("");
  const qrCodeRef = useRef(null);

  const generateQRDataUrl = () => {
    if (!qrCodeRef.current) return "";

    const svgElement = qrCodeRef.current.querySelector("svg");
    if (!svgElement) return "";

    // Clone the SVG to avoid modifying the original
    const svgClone = svgElement.cloneNode(true);

    // Set explicit width/height for the clone
    svgClone.setAttribute("width", "512px");
    svgClone.setAttribute("height", "512px");

    const svgString = new XMLSerializer().serializeToString(svgClone);
    const svgBlob = new Blob([svgString], {
      type: "image/svg+xml;charset=utf-8",
    });
    return URL.createObjectURL(svgBlob);
  };

  const handlePreviewClick = (_id) => {
    const qrData = JSON.stringify({
      order_id: orderData?._id,
      product_id: _id,
      status: "delivered",
    });
    setOrderId(qrData);
    setTimeout(() => {
      const dataUrl = generateQRDataUrl();
      setQrCodeDataUrl(dataUrl);
      setOpenLightboxQR(true);
    }, 100);
  };

  // Clean up object URLs when component unmounts
  React.useEffect(() => {
    return () => {
      if (qrCodeDataUrl) {
        URL.revokeObjectURL(qrCodeDataUrl);
      }
    };
  }, [qrCodeDataUrl]);

  const [expandedBreakdowns, setExpandedBreakdowns] = useState({});

  const toggleBreakdown = (productId) => {
    setExpandedBreakdowns((prev) => ({
      ...prev,
      [productId]: !prev[productId],
    }));
  };

  return (
    <>
      <ToastContainer />
      <Row>
        <Col className="10">
          <div className="page-title-box">
            <h4>Order Management</h4>
            <ol className="breadcrumb m-0">
              <li className="breadcrumb-item active">Order Management</li>:{" "}
              <li className="breadcrumb-item">Manufacturer Order details</li>
            </ol>
          </div>
        </Col>
        <div className="col-md-2 text-end">
          <button
            type="button"
            class="btn btn-primary btn-lg"
            onClick={() => history.back()}
          >
            <i class="fas fa-chevron-left"></i> Back
          </button>
        </div>

        {loader ? (
          <CardBody style={{ height: "100px" }}>
            <Spinner
              color="info"
              style={{
                height: "4rem",
                width: "4rem",
                position: "absolute",
                left: "50%",
              }}
            >
              Loading...
            </Spinner>
          </CardBody>
        ) : (
          <>
            <Card className="custom-card">
              <div
                className="cover-image"
                style={{ backgroundColor: "rgb(29, 155, 240)" }}
              ></div>
              <div className="profile-image">
                <img
                  src={
                    userAllDetails?.logo
                      ? userAllDetails?.logo
                      : `https://ui-avatars.com/api/?background=random&name=${userAllDetails?.companyName}`
                  }
                  onClick={() =>
                    showLightBox(
                      userAllDetails?.logo
                        ? userAllDetails?.logo
                        : `https://ui-avatars.com/api/?background=random&name=${userAllDetails?.companyName}`
                    )
                  }
                  alt="Image Not Available"
                />
              </div>
              <br></br>

              <div className="row my-2 py-2">
                <div
                  className="userinfo col-md-12 "
                  style={{ paddingLeft: "20px" }}
                >
                  <div className="fst mt-3">
                    {" "}
                    <h3> {userAllDetails?.companyName} </h3>{" "}
                  </div>
                  <div className="row">
                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Owner Name :{" "}
                        <span>
                          {" "}
                          {userAllDetails?.first_name +
                            " " +
                            userAllDetails?.last_name}{" "}
                        </span>{" "}
                      </p>{" "}
                    </div>
                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Email: <span>{userAllDetails?.email}</span>{" "}
                      </p>{" "}
                    </div>
                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Address: <span> {userAllDetails?.address} </span>{" "}
                      </p>{" "}
                    </div>
                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Mobile No. <span> {userAllDetails?.mobile} </span>{" "}
                      </p>{" "}
                    </div>
                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Payment Terms :{" "}
                        <span className="text-capitalize">
                          {" "}
                          {userAllDetails?.type}{" "}
                        </span>{" "}
                      </p>{" "}
                    </div>
                    {userAllDetails?.type == "postpaid" && (
                      <div className="col-md-4 fst py-1">
                        {" "}
                        <p>
                          {" "}
                          Credit Period (Days):{" "}
                          <span> {userAllDetails?.creditDays} </span>{" "}
                        </p>{" "}
                      </div>
                    )}
                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Delivery Terms :{" "}
                        <span className="text-capitalize">
                          {userAllDetails?.deliveryTerms === "self"
                            ? "Self-Delivery"
                            : "Pickup Suppliers"}{" "}
                        </span>{" "}
                      </p>{" "}
                    </div>

                    {/* <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Country: <span> {userAllDetails?.country} </span>{" "}
                      </p>{" "}
                    </div> */}

                    {/* <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Country Code: <span> {userAllDetails?.country_code} </span>{" "}
                      </p>{" "}
                    </div>

                    <div className="col-md-4 fst py-1">
                      <p>
                        {" "}
                        Created At:
                        <span> {formatDate(userAllDetails?.createdAt)}</span>
                      </p>
                    </div> */}
                  </div>
                </div>
              </div>
            </Card>

            <Col md="12">
              <div className="card">
                <div className="card-body ">
                  {orderData?.orderStatus !== "cancelled" && (
                    <>
                      {orderData?.paymentRefImage === "" && (
                        <div
                          className="order-info"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "22px",
                            background: "whitesmoke",
                            display: "inline-block",
                            padding: "16px",
                            borderRadius: "7px",
                          }}
                        >
                          <div>
                            <h4>Upload the receipt here</h4>
                            <div className="mb-2">
                              <label>Reference Number</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Please reference number..."
                                value={refrenshNumber}
                                onChange={(e) =>
                                  setRefrenshNumber(e.target.value)
                                }
                              />
                            </div>
                            <label className="mb-2">Upload receipt</label>
                            {isFileSelect && (
                              <div className="img-rececipt-group">
                                {veriFiedDocument?.map((i) => (
                                  <img
                                    key={i.previewUrl}
                                    onClick={() =>
                                      handleViewModal(i?.previewUrl)
                                    }
                                    src={i?.previewUrl}
                                    width={"50px"}
                                  />
                                ))}
                              </div>
                            )}
                            <input
                              multiple
                              type="file"
                              onChange={(e) => {
                                const files = e.target.files;
                                if (files.length > 0) {
                                  updateDocument("doc", files);
                                }
                              }}
                              className="form-control"
                            />
                            <button
                              disabled={!isFileSelect}
                              onClick={() => handleReceipt(orderData?._id)}
                              className="btn btn-primary mt-3"
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      )}
                    </>
                  )}

                  <div className="row" style={{ textTransform: "capitalize" }}>
                    <h3>Payment Overview</h3>
                    <div
                      className="row"
                      style={{ textTransform: "capitalize" }}
                    >
                      <div className="col-md-12 fst py-1">
                        <p className="mb-0">
                          kulies Commission : &nbsp;
                          <span className="status-bg-span">
                            ${orderData?.kuliesCommission}
                          </span>
                        </p>
                      </div>
                      <div className="col-md-12 fst py-1">
                        <p className="mb-0">
                          Total Amount : &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
                          &nbsp;&nbsp;&nbsp;
                          <span className="status-bg-span">
                            $
                            {orderData?.kuliesCommission
                              ? orderData?.totalAmount -
                              orderData?.kuliesCommission
                              : orderData?.totalAmount}
                          </span>
                        </p>
                      </div>
                      <div
                        className="col-md-3 fst py-1"
                        style={{ width: "auto" }}
                      >
                        <p className="mb-0">
                          Payment Terms : &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
                          &nbsp;&nbsp;&nbsp;
                          <span className="status-bg-span">
                            {userAllDetails?.type}
                          </span>
                        </p>
                      </div>
                      <div className="col-md-9 fst py-1">
                        <p className="mb-0">
                          Credit Period (Days) &nbsp;&nbsp;&nbsp;
                          &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;
                          <span className="status-bg-span"></span>
                        </p>
                      </div>
                    </div>
                    <div className="col-md-2 fst py-1">
                      <p className="mb-0">
                        Payment Status.{" "}
                        <span
                          className="status-bg-span"
                          style={{
                            color:
                              orderData?.adminPayStatus === "completed" ||
                                orderData?.adminPayStatus === "paid"
                                ? "#4caf50"
                                : orderData?.adminPayStatus === "Cancelled"
                                  ? "#ec536c"
                                  : "#FF9800",
                          }}
                        >
                          <b>{orderData?.adminPayStatus}</b>
                        </span>
                      </p>
                    </div>
                    <div className="col-md-3 fst py-1">
                      <p className="mb-0">
                        Manufacturer Pay Status:{" "}
                        <span
                          className="status-bg-span"
                          style={{
                            color:
                              orderData?.manufacturerPayStatus === "received" ||
                                orderData?.manufacturerPayStatus === "paid"
                                ? "#4caf50"
                                : orderData?.manufacturerPayStatus ===
                                  "notRecieved"
                                  ? "#ec536c"
                                  : "#FF9800",
                          }}
                        >
                          <b> {orderData?.manufacturerPayStatus}</b>
                        </span>
                      </p>
                    </div>

                    {orderData?.paymentRefNumber !== "" ? (
                      <div className="col-md-3 fst py-1">
                        <p className="mb-0">
                          Payment Ref Number:
                          <span className="status-bg-span">
                            {orderData?.paymentRefNumber}
                          </span>
                        </p>
                      </div>
                    ) : (
                      <div className="col-md-3 fst py-1">
                        <p className="mb-0">
                          Payment Ref Number:{" "}
                          <span className="status-bg-span">Not Available</span>
                        </p>
                      </div>
                    )}

                    <div className="col-md-4 fst d-flex gap-2 py-1">
                      <p className="mb-0">Payment Receipt:</p>
                      <div className=" d-flex gap-2 align-items-center">
                        <div style={{ cursor: "pointer" }}>
                          <img
                            onClick={() =>
                              showLightBox(orderData?.paymentRefImage)
                            }
                            src={orderData?.paymentRefImage}
                            width={"40px"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>

            <Col md="12">
              <div className="card">
                <div className="card-body ">
                  <div className="row" style={{ textTransform: "capitalize" }}>
                    <h3>Order Overview</h3>

                    <div className="col-md-4 fst py-1">
                      <p className="mb-0">
                        Order id:
                        <span className="status-bg-span">{orderData?._id}</span>
                      </p>
                    </div>

                    <div className="col-md-4 fst py-1">
                      <p className="mb-0">
                        Order Date:
                        <span className="status-bg-span">
                          {formatDate(orderData?.createdAt)}
                        </span>
                      </p>
                    </div>
                    {orderData?.deliveryDate !== "" && (
                      <div className="col-md-3 fst py-1">
                        <p className="mb-0">
                          Delivery Date:
                          <span className="status-bg-span">
                            {formatDate(orderData?.deliveryDate)}
                          </span>
                        </p>
                      </div>
                    )}

                    {/* <div className="col-md-2 fst py-1">
                      <p className="mb-0">
                        Order Status:{" "}
                        <span
                          className="status-bg-span"
                          style={{
                            color:
                              orderData?.orderStatus === "pending"
                                ? "rgb(255, 152, 0)" // Yellow
                                : orderData?.orderStatus === "confirmed"
                                ? "#2196F3" // Blue
                                : orderData?.orderStatus === "cancelled"
                                ? "#EC536C" // Red
                                : orderData?.orderStatus === "delivered"
                                ? "green" // Green
                                : orderData?.orderStatus === "inTransit"
                                ? "#FF9800" // Orange
                                : orderData?.orderStatus === "processing"
                                ? "#673AB7" // Purple
                                : orderData?.orderStatus === "shipped"
                                ? "#3F51B5" // Dark Blue
                                : orderData?.orderStatus === "outForDelivery"
                                ? "#009688" // Teal
                                : orderData?.orderStatus === "failed"
                                ? "#F44336" // Dark Red
                                : "#4CAF50", // Default Green
                          }}
                        >
                          <b>{orderData?.orderStatus}</b>
                        </span>
                      </p>
                    </div> */}

                    <div className="col-md-4 fst py-1">
                      <p className="mb-0">
                        View invoice: &nbsp;&nbsp;
                        <button
                          type="button"
                          className="btn btn-primary"
                          style={{
                            padding: "2px 12px",
                            display: "inline-flex",
                          }}
                        >
                          <a href={`${orderData?.invoice}`} target="_blank">
                            <i className="i text-white fa fa-eye"></i>
                          </a>
                        </button>
                      </p>
                    </div>
                  </div>

                  <div className="row" style={{ textTransform: "capitalize" }}>
                    <div className="col-md-4 fst py-1">
                      <p className="mb-0">
                        Order Status:{" "}
                        <span
                          className="status-bg-span"
                          style={{
                            color:
                              orderData?.orderStatus === "pending"
                                ? "rgb(255, 152, 0)" // Yellow
                                : orderData?.orderStatus === "confirmed"
                                  ? "#2196F3" // Blue
                                  : orderData?.orderStatus === "cancelled"
                                    ? "#EC536C" // Red
                                    : orderData?.orderStatus === "delivered"
                                      ? "green" // Green
                                      : orderData?.orderStatus === "assigned"
                                        ? "#FF9800" // Orange
                                        : "#4CAF50", // Default Green
                          }}
                        >
                          <b>{orderData?.orderStatus}</b>
                        </span>
                        {orderData?.orderStatus === "pending" && (
                          <span className="d-block small text-muted">
                            Order placed - waiting for supplier to confirm the
                            order
                          </span>
                        )}
                        {orderData?.orderStatus === "confirmed" && (
                          <span className="d-block small text-muted">
                            Order has been confirmed by supplier. Assign a
                            delivery agent to pickup the order from the
                            manufacturer
                          </span>
                        )}
                        {orderData?.orderStatus === "delivered" && (
                          <span className="d-block small text-muted">
                            Order has been delivered to the user
                          </span>
                        )}
                      </p>
                    </div>

                    <div className="col-md-4 fst py-1">
                      <p className="mb-0">
                        invoice Number:
                        <span className="status-bg-span">
                          {orderData?.invoiceId}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>

            <Col md="12" className="mt-3">
              <div className="card">
                <div className="card-body">
                  <div className="tab-content clearfix">
                    <div
                      className="tab-pane active show padded-tab"
                      id="shopes"
                    >
                      {/* <ShoplistTable userId={userAllDetails?._id} /> */}
                      <div className="mb-2 mt-1 text-end">
                        {selectedProducts?.length > 1 && (
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => {
                              toggleModel();
                            }}
                          >
                            Assign Delivery
                          </button>
                        )}
                      </div>
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            {orderData?.orderStatus === "confirmed" &&
                              userAllDetails?.deliveryTerms === "assign" && (
                                <th>
                                  <input
                                    style={{
                                      height: "20px",
                                      width: "21px",
                                      cursor: "pointer",
                                    }}
                                    type="checkbox"
                                    onChange={handleSelectAll}
                                    checked={
                                      orderData?.products?.length > 0 &&
                                      selectedProducts.length ===
                                      orderData?.products?.filter(
                                        (item) =>
                                          item.deliveryStatus === "pending"
                                      ).length &&
                                      selectedProducts.length > 0
                                    }
                                  />
                                </th>
                              )}
                            <th tabIndex={0}>S.NO</th>
                            <th tabIndex={0}>Product Image</th>
                            <th tabIndex={0}>Product Name</th>
                            {/* <th tabIndex={0}>Description	</th> */}
                            <th tabIndex={0}>Quantity</th>
                            <th tabIndex={0}>Price</th>
                            <th tabIndex={0}>Total Amount</th>
                            {/* <th tabIndex={0}>Action</th> */}
                            <th tabIndex={0}>Delivery Status</th>
                            <th tabIndex={0}>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {orderData?.products?.map((item, index) => {
                            const isFirstSelected =
                              selectedProducts.length > 0 &&
                              selectedProducts[0] === item.productId;
                            const hasBreakdown = !!item.deliveryBreakdown;

                            return (
                              <React.Fragment key={index}>
                                <tr>
                                  {orderData?.orderStatus === "confirmed" &&
                                    userAllDetails?.deliveryTerms ===
                                    "assign" && (
                                      <td>
                                        {item?.deliveryStatus === "pending" && (
                                          <input
                                            style={{
                                              height: "20px",
                                              width: "20px",
                                              cursor: "pointer",
                                            }}
                                            type="checkbox"
                                            checked={selectedProducts.includes(
                                              item.productId
                                            )}
                                            onChange={(e) =>
                                              handleSelectOne(
                                                e,
                                                item.productId,
                                                item
                                              )
                                            }
                                          />
                                        )}
                                      </td>
                                    )}
                                  <td>{index + 1}</td>
                                  <td>
                                    <img
                                      src={item?.images?.[0]}
                                      alt="Not found Product"
                                      width="50px"
                                    />
                                  </td>
                                  <td>{item?.name}</td>
                                  <td>{item?.quantity}</td>
                                  <td>${item?.price}</td>
                                  <td>${item?.totalPrice}</td>
                                  <td>
                                    {item?.deliveryStatus === "pending" ? (
                                      <button
                                        disabled={
                                          !isFirstSelected ||
                                          selectedProducts?.length > 1
                                        }
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={() => {
                                          toggleModel();
                                        }}
                                      >
                                        Assign Delivery
                                      </button>
                                    ) : (
                                      <>
                                        <div>
                                          <Link
                                            to={{
                                              pathname:
                                                "/delivery-agents-details",
                                              state: item?.deliveryAgent,
                                            }}
                                            className="d-flex align-items-center justify-content-start text-start"
                                            style={{ gap: "10px" }}
                                          >
                                            <span>
                                              <img
                                                src={item?.deliveryAgent?.image}
                                                width="50px"
                                              />
                                            </span>
                                            <div style={{ color: "#696464" }}>
                                              <span>
                                                Name :{" "}
                                                {item?.deliveryAgent
                                                  ?.first_name +
                                                  item?.deliveryAgent
                                                    ?.last_name}
                                              </span>
                                              <br />
                                              <span>
                                                {" "}
                                                {item?.deliveryAgent?.email}
                                              </span>
                                              <br />
                                              <span>
                                                Status :{" "}
                                                <span
                                                  className="status-bg-span text-capitalize"
                                                  style={
                                                    item?.deliveryStatus ===
                                                      "cancelled"
                                                      ? { color: "#ec536c" }
                                                      : item?.deliveryStatus ===
                                                        "failed"
                                                        ? { color: "#ec536c" }
                                                        : item?.deliveryStatus ===
                                                          "pending"
                                                          ? { color: "#FF9800" }
                                                          : item?.deliveryStatus ===
                                                            "assigned"
                                                            ? { color: "#FF9800" }
                                                            : { color: "#4caf50" }
                                                  }
                                                >
                                                  {" "}
                                                  {item?.deliveryStatus}{" "}
                                                </span>
                                              </span>
                                            </div>
                                          </Link>

                                          {item?.deliveryStatus ===
                                            "pickedUp" && (
                                              <>
                                                <div
                                                  ref={qrCodeRef}
                                                  style={{
                                                    cursor: "pointer",
                                                    display: "inline-block",
                                                  }}
                                                  onClick={() =>
                                                    handlePreviewClick(
                                                      item?.productId
                                                    )
                                                  }
                                                >
                                                  <QRCodeSVG
                                                    style={{ display: "none" }}
                                                    value={orderId}
                                                    size={40}
                                                    level="H"
                                                    includeMargin={true}
                                                  />
                                                  <button
                                                    type="button"
                                                    className="btn mt-2 btn-primary"
                                                  >
                                                    Mark As Received
                                                  </button>
                                                </div>
                                                {/* Lightbox */}
                                                {openLightboxQR &&
                                                  qrCodeDataUrl && (
                                                    <Lightbox
                                                      mainSrc={qrCodeDataUrl}
                                                      onCloseRequest={() =>
                                                        setOpenLightboxQR(false)
                                                      }
                                                      enableZoom={true}
                                                    />
                                                  )}
                                              </>
                                            )}
                                        </div>
                                      </>
                                    )}
                                  </td>
                                  <td>
                                    {hasBreakdown ? (
                                      <button
                                        className="btn btn-sm btn-info"
                                        onClick={() =>
                                          toggleBreakdown(item.productId)
                                        }
                                      >
                                        {expandedBreakdowns[item.productId]
                                          ? "Hide Breakdown"
                                          : "Show Breakdown"}
                                      </button>
                                    ) : (
                                      "N/A"
                                    )}
                                  </td>
                                </tr>

                                {expandedBreakdowns[item.productId] &&
                                  hasBreakdown && (
                                    <tr>
                                      <td colSpan="9" className="p-0">
                                        <div className="p-3 bg-light">
                                          {/* <h5 className="mb-3">Order Breakdown Details</h5> */}

                                          <div className="table-responsive p-3 rounded shadow-sm bg-white">
                                            <table className="table table-bordered align-middle mb-0">
                                              <thead className="table-light text-center">
                                                <tr>
                                                  <th
                                                    scope="col"
                                                    style={{ width: "10%" }}
                                                  >
                                                    Sr. No
                                                  </th>
                                                  <th
                                                    scope="col"
                                                    style={{ width: "30%" }}
                                                  >
                                                    Order ID
                                                  </th>
                                                  <th
                                                    scope="col"
                                                    style={{ width: "30%" }}
                                                  >
                                                    User Details
                                                  </th>
                                                  <th
                                                    scope="col"
                                                    style={{ width: "20%" }}
                                                  >
                                                    Quantity
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {item.deliveryBreakdown.userOrderDetail?.map(
                                                  (detail, idx) => (
                                                    <tr key={idx}>
                                                      <td
                                                        className="text-center align-middle bg-white"
                                                        style={{
                                                          fontSize: "14px",
                                                        }}
                                                      >
                                                        {idx + 1}
                                                      </td>
                                                      <td
                                                        className="text-break align-middle text-center bg-white"
                                                        style={{
                                                          fontSize: "14px",
                                                        }}
                                                      >
                                                        {detail.orderId}
                                                      </td>
                                                      <td
                                                        className="align-middle bg-white"
                                                        style={{
                                                          fontSize: "14px",
                                                        }}
                                                      >
                                                        <div className="d-flex align-items-center gap-3">
                                                          {detail.user
                                                            ?.photo && (
                                                              <img
                                                                src={
                                                                  detail.user
                                                                    .photo
                                                                }
                                                                alt="User"
                                                                width="50"
                                                                height="50"
                                                                style={{
                                                                  objectFit:
                                                                    "cover",
                                                                  cursor:
                                                                    "pointer",
                                                                  borderRadius:
                                                                    "8px",
                                                                }}
                                                                onClick={() =>
                                                                  showLightBox(
                                                                    detail.user
                                                                      .photo
                                                                  )
                                                                }
                                                              />
                                                            )}
                                                          <div>
                                                            <div className="fw-semibold text-start">
                                                              {
                                                                detail.user
                                                                  ?.first_name
                                                              }{" "}
                                                              {
                                                                detail.user
                                                                  ?.last_name
                                                              }
                                                            </div>
                                                            <div className="text-muted  text-start">
                                                              {
                                                                detail.user
                                                                  ?.email
                                                              }
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </td>

                                                      <td
                                                        className="text-center align-middle bg-white"
                                                        style={{
                                                          fontSize: "14px",
                                                        }}
                                                      >
                                                        {detail.quantity}
                                                      </td>
                                                    </tr>
                                                  )
                                                )}
                                              </tbody>
                                            </table>
                                          </div>

                                          {/* Warehouse Breakdown Table */}
                                          <div className="table-responsive p-3 rounded shadow-sm bg-white mt-4">
                                            <h6 className="mb-3">
                                              Warehouse Information
                                            </h6>
                                            <table className="table table-bordered align-middle mb-0">
                                              <thead className="table-light text-center">
                                                <tr>
                                                  <th style={{ width: "20%" }}>
                                                    Warehouse Name
                                                  </th>
                                                  <th style={{ width: "30%" }}>
                                                    Address
                                                  </th>
                                                  {/* <th style={{ width: "10%" }}>Phone</th> */}
                                                  {/* <th style={{ width: "10%" }}>City</th> */}
                                                  {/* <th style={{ width: "10%" }}>State</th> */}
                                                  {/* <th style={{ width: "10%" }}>Capacity</th> */}
                                                  <th style={{ width: "10%" }}>
                                                    Quantity to Warehouse
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                <tr
                                                  className="text-center bg-white"
                                                  style={{ fontSize: "14px" }}
                                                >
                                                  <td
                                                    style={{
                                                      backgroundColor: "white",
                                                    }}
                                                  >
                                                    {item?.warehouse?.name ||
                                                      "N/A"}
                                                  </td>
                                                  <td
                                                    style={{
                                                      backgroundColor: "white",
                                                    }}
                                                  >
                                                    {item?.warehouse?.address ||
                                                      "N/A"}
                                                  </td>
                                                  {/* <td>{item?.warehouse?.phone || "N/A"}</td> */}
                                                  {/* <td>{item?.warehouse?.city || "N/A"}</td> */}
                                                  {/* <td>{item?.warehouse?.state || "N/A"}</td> */}
                                                  {/* <td>{item?.warehouse?.capacity || "N/A"}</td> */}
                                                  <td
                                                    style={{
                                                      backgroundColor: "white",
                                                    }}
                                                  >
                                                    {item?.deliveryBreakdown
                                                      ?.quantityToWarehouse ||
                                                      0}
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                              </React.Fragment>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>

                    <div className="tab-pane padded-tab" id="Order">
                      <div className="custom-card">
                        {/* <div
                      className="cover-image"
                      style={{ backgroundColor: "rgb(29, 155, 240)" }}
                    /> */}
                        {orderData?.deliveryAddress?.addrestype === "shop" ? (
                          <>
                            <div className="profile-images">
                              <img
                                src={
                                  orderData?.shopDetails?.image
                                    ? orderData?.shopDetails?.image
                                    : `https://ui-avatars.com/api/?background=random&name=${orderData?.shopDetails?.shopName}`
                                }
                                onClick={() =>
                                  showLightBox(
                                    orderData?.shopDetails?.image
                                      ? orderData?.shopDetails?.image
                                      : `https://ui-avatars.com/api/?background=random&name=${orderData?.shopDetails?.shopName}`
                                  )
                                }
                                alt="Image Not Available"
                              />
                            </div>
                            <br />
                            <div className="row my-2 py-2">
                              <div
                                className="userinfo col-md-12 "
                                style={{ paddingLeft: 20 }}
                              >
                                <div className="fst">
                                  {" "}
                                  <h3>
                                    {" "}
                                    {orderData?.shopDetails?.shopName}{" "}
                                  </h3>{" "}
                                </div>
                                <div className="row">
                                  <div className="col-md-4 fst py-1">
                                    {" "}
                                    <p>
                                      {" "}
                                      Email:{" "}
                                      <span>
                                        {orderData?.shopDetails?.email}
                                      </span>{" "}
                                    </p>{" "}
                                  </div>
                                  <div className="col-md-4 fst py-1">
                                    {" "}
                                    <p>
                                      {" "}
                                      Mobile No.:{" "}
                                      <span>
                                        {" "}
                                        {orderData?.shopDetails?.phone}{" "}
                                      </span>{" "}
                                    </p>{" "}
                                  </div>
                                  <div className="col-md-4 fst py-1">
                                    {" "}
                                    <p>
                                      {" "}
                                      City:{" "}
                                      <span>
                                        {" "}
                                        {orderData?.shopDetails?.city}{" "}
                                      </span>{" "}
                                    </p>{" "}
                                  </div>
                                  {/* <div className="col-md-4 fst py-1">
                            {" "}
                            <p>
                              {" "}
                              Status: <span> {orderData?.shopDetails?.state} </span>{" "}
                            </p>{" "}
                          </div> */}
                                  <div className="col-md-4 fst py-1">
                                    {" "}
                                    <p>
                                      {" "}
                                      State:{" "}
                                      <span>
                                        {" "}
                                        {orderData?.shopDetails?.state}{" "}
                                      </span>{" "}
                                    </p>{" "}
                                  </div>
                                  <div className="col-md-4 fst py-1">
                                    {" "}
                                    <p>
                                      {" "}
                                      Post Code:{" "}
                                      <span>
                                        {" "}
                                        {orderData?.shopDetails?.postCode}{" "}
                                      </span>{" "}
                                    </p>{" "}
                                  </div>
                                  <div className="col-md-4 fst py-1">
                                    <p>
                                      {" "}
                                      Landmark
                                      <span>
                                        {orderData?.shopDetails?.landmark}
                                      </span>
                                    </p>
                                  </div>
                                  <div className="col-md-4 fst py-1">
                                    <p>
                                      Address Line 1&nbsp;&nbsp;
                                      <span>
                                        {state?.shopDetails?.addressLine1}
                                      </span>
                                    </p>
                                  </div>
                                  <div className="col-md-4 fst py-1">
                                    <p>
                                      {" "}
                                      Address Line 2&nbsp;&nbsp;
                                      <span>
                                        {" "}
                                        {state?.shopDetails?.addressLine2}{" "}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>{" "}
                          </>
                        ) : (
                          <>
                            <div className="row my-2 py-2">
                              <div
                                className="userinfo col-md-12 "
                                style={{ paddingLeft: 20 }}
                              >
                                <div className="row">
                                  <div className="col-md-4 fst py-1">
                                    {" "}
                                    <p>
                                      {" "}
                                      Address Type:{" "}
                                      <span>
                                        {orderData?.deliveryAddress?.addrestype}
                                      </span>{" "}
                                    </p>{" "}
                                  </div>
                                  <div className="col-md-4 fst py-1">
                                    {" "}
                                    <p>
                                      {" "}
                                      Email:{" "}
                                      <span>
                                        {orderData?.deliveryAddress?.email}
                                      </span>{" "}
                                    </p>{" "}
                                  </div>
                                  <div className="col-md-4 fst py-1">
                                    {" "}
                                    <p>
                                      {" "}
                                      Mobile No.:{" "}
                                      <span>
                                        {" "}
                                        {orderData?.deliveryAddress?.phone}{" "}
                                      </span>{" "}
                                    </p>{" "}
                                  </div>
                                  <div className="col-md-4 fst py-1">
                                    {" "}
                                    <p>
                                      {" "}
                                      City:{" "}
                                      <span>
                                        {" "}
                                        {orderData?.deliveryAddress?.city}{" "}
                                      </span>{" "}
                                    </p>{" "}
                                  </div>
                                  {/* <div className="col-md-4 fst py-1">
                            {" "}
                            <p>
                              {" "}
                              Status: <span> {orderData?.deliveryAddress?.state} </span>{" "}
                            </p>{" "}
                          </div> */}
                                  <div className="col-md-4 fst py-1">
                                    {" "}
                                    <p>
                                      {" "}
                                      State:{" "}
                                      <span>
                                        {" "}
                                        {orderData?.deliveryAddress?.state}{" "}
                                      </span>{" "}
                                    </p>{" "}
                                  </div>
                                  <div className="col-md-4 fst py-1">
                                    {" "}
                                    <p>
                                      {" "}
                                      Post Code:{" "}
                                      <span>
                                        {" "}
                                        {
                                          orderData?.deliveryAddress?.postCode
                                        }{" "}
                                      </span>{" "}
                                    </p>{" "}
                                  </div>
                                  <div className="col-md-4 fst py-1">
                                    <p>
                                      {" "}
                                      Landmark
                                      <span>
                                        {orderData?.deliveryAddress?.landmark}
                                      </span>
                                    </p>
                                  </div>
                                  <div className="col-md-4 fst py-1">
                                    <p>
                                      Address Line 1&nbsp;&nbsp;
                                      <span>
                                        {state?.deliveryAddress?.addressLine1}
                                      </span>
                                    </p>
                                  </div>
                                  <div className="col-md-4 fst py-1">
                                    <p>
                                      {" "}
                                      Address Line 2&nbsp;&nbsp;
                                      <span>
                                        {" "}
                                        {
                                          state?.deliveryAddress?.addressLine2
                                        }{" "}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>

                    <div className="tab-pane padded-tab" id="Assigned">
                      <div className="custom-card card">
                        <div className="profile-images">
                          <img
                            src={
                              orderData?.trackingDetails?.image
                                ? orderData?.trackingDetails?.image
                                : `https://ui-avatars.com/api/?background=random&name=${orderData?.trackingDetails?.first_name +
                                orderData?.trackingDetails?.last_name
                                }`
                            }
                            onClick={() =>
                              showLightBox(
                                orderData?.trackingDetails?.image
                                  ? orderData?.trackingDetails?.image
                                  : $`https://ui-avatars.com/api/?background=random&name=${orderData?.trackingDetails?.first_name +
                                    orderData?.trackingDetails?.last_name
                                    }`
                              )
                            }
                            alt="Image Not Available"
                            width="70px"
                          />
                        </div>
                        <br />
                        <div className="row my-2 py-2">
                          <div
                            className="userinfo col-md-12 "
                            style={{ paddingLeft: 20 }}
                          >
                            <div className="fst">
                              {" "}
                              <h3>
                                {" "}
                                {orderData?.trackingDetails?.first_name}{" "}
                                {orderData?.trackingDetails?.last_name}{" "}
                              </h3>{" "}
                            </div>
                            <div className="row">
                              <div className="col-md-4 fst py-1">
                                {" "}
                                <p>
                                  {" "}
                                  Email:{" "}
                                  <span>
                                    {orderData?.trackingDetails?.email}
                                  </span>{" "}
                                </p>{" "}
                              </div>
                              <div className="col-md-4 fst py-1">
                                {" "}
                                <p>
                                  {" "}
                                  Mobile No.:{" "}
                                  <span>
                                    {" "}
                                    {orderData?.trackingDetails?.phone}{" "}
                                  </span>{" "}
                                </p>{" "}
                              </div>

                              <div className="col-md-4 fst py-1">
                                {" "}
                                <p>
                                  {" "}
                                  Assigned Date.:{" "}
                                  <span>
                                    {moment(orderData?.updatedAt).format(
                                      "DD-MM-YYYY hh:mm"
                                    )}
                                  </span>{" "}
                                </p>{" "}
                              </div>

                              {/* <div className="col-md-4 fst py-1">
                            {" "}
                            <p>
                              {" "}
                              Status: <span> {orderData?.shopDetails?.state} </span>{" "}
                            </p>{" "}
                          </div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </>
        )}

        <DeliveryAgents
          show={model}
          manufacturersType={"manufacturers"}
          selectedProductsData={selectedProductsData}
          orderId={_id?.id}
          allData={orderData}
          closeModal={closeModalDeleveryAgent}
          selectRow={selectRow}
        />

        {openLightbox && (
          <Lightbox
            mainSrc={imageLB}
            onCloseRequest={() => setOpenLightBox(false)}
          />
        )}
      </Row>
      <ToastContainer />{" "}
    </>
  );
}
